import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PatentSelectionService } from '../patent-selection-service';
import { PatentCacheService } from '../patent-cache-service';
import { FtoProApi } from '../../apis/fto-pro-api';
import { CurrentTaskService } from '@/services/current-task/current-task-service';

/**
 * 专利选择服务实现
 */
@injectable()
export class PatentSelectionServiceImpl implements PatentSelectionService {
    constructor(
        @inject(PatentCacheService)
        private readonly _patentCacheService: PatentCacheService,
        @inject(FtoProApi)
        private readonly _ftoProApi: FtoProApi,
        @inject(CurrentTaskService)
        private readonly _currentTaskService: CurrentTaskService,
    ) {}

    async addPatent(searchIndex: number, patentId: string): Promise<boolean> {
        // 检查专利是否存在且未选中
        const patents = this._patentCacheService.getPatentData(searchIndex);
        const patent = patents.find(p => p.patentId === patentId);

        if (!patent) {
            return false;
        }

        if (patent.selected) {
            return false;
        }

        // 更新专利选择状态
        const success = this._patentCacheService.updatePatentSelection(searchIndex, patentId, true);

        if (success) {
            // 调用分析API
            try {
                await this._ftoProApi.analyzePatent({
                    task_id: this._currentTaskService.taskId,
                    search_index: searchIndex,
                    patent_id: patentId,
                    selected: true,
                });
            } catch (error) {
                console.error('Failed to analyze patent:', error);
                // 不影响主流程，继续返回成功
            }
        }

        return success;
    }

    async removePatent(searchIndex: number, patentId: string): Promise<boolean> {
        // 检查专利是否存在且已选中
        const patents = this._patentCacheService.getPatentData(searchIndex);
        const patent = patents.find(p => p.patentId === patentId);

        if (!patent) {
            return false;
        }

        if (!patent.selected) {
            return false;
        }

        // 更新专利选择状态
        const success = this._patentCacheService.updatePatentSelection(searchIndex, patentId, false);

        if (success) {
            // 调用分析API
            try {
                await this._ftoProApi.analyzePatent({
                    task_id: this._currentTaskService.taskId,
                    search_index: searchIndex,
                    patent_id: patentId,
                    selected: false,
                });
            } catch (error) {
                console.error('Failed to analyze patent:', error);
                // 不影响主流程，继续返回成功
            }
        }

        return success;
    }
}
